import React from "react";
import { Check, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const FEATURES = [
  { key: "plan.feat.scanner", free: true },
  { key: "plan.feat.library", free: true },
  { key: "plan.feat.pubmedBasic", free: true },
  { key: "plan.feat.pubmedStudies", free: false },
  { key: "plan.feat.expertDose", free: false },
  { key: "plan.feat.condition", free: false },
  { key: "plan.feat.formula", free: false },
];

export const PlanComparison = () => {
  const { t } = useLang();
  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white" data-testid="plan-comparison-table">
      <div className="grid grid-cols-[1fr_auto_auto] items-center gap-2 border-b border-gray-100 bg-gray-50 px-5 py-3">
        <span className="text-xs font-bold uppercase tracking-wider text-gray-400">{t("plan.comparisonTitle")}</span>
        <span className="w-16 text-center text-xs font-bold uppercase tracking-wider text-gray-500">{t("plan.free")}</span>
        <span className="w-16 text-center text-xs font-bold uppercase tracking-wider text-emerald-600">{t("plan.premium")}</span>
      </div>
      {FEATURES.map((f) => (
        <div key={f.key} className="grid grid-cols-[1fr_auto_auto] items-center gap-2 border-b border-gray-50 px-5 py-3 last:border-0">
          <span className="text-sm font-medium text-gray-700">{t(f.key)}</span>
          <span className="flex w-16 justify-center">
            {f.free ? <Check size={17} className="text-emerald-500" /> : <X size={17} className="text-gray-300" />}
          </span>
          <span className="flex w-16 justify-center">
            <Check size={17} className="text-emerald-500" />
          </span>
        </div>
      ))}
    </div>
  );
};

export default PlanComparison;
